import { createPersistentSignal } from "s-tools-utils-kit";

export const domainSignal = createPersistentSignal<{
  id: number;
  name: string;
  companyDomain: string;
  companyLogo: string;
  companyName: string;
  companyLogoName: string;
  companySkin: number;
  companyAccount: string;
  companyPwd: string;
  companyMail: string;
  companyMailPwd: string;
  logo1: string;
  logo2: string;
  logo3: string;
  logo4: string;
  logo5: string;
  logo6: string;
  pcLogo1: string;
  pcLogo2: string;
  pcLogo3: string;
  pcLogo4: string;
  pcLogo5: string;
  pcLogo6: string;
  phoneDomian: string;
  iosDomain: string;
  androidDomain: string;
  status: number;
  isDel: number;
  leverFee: number;
  hyFee: number;
  kjFee: number;
  inviteType: number;
  appStatus: number;
  c2ctxStatus: number;
  c2cczStatus: number;
  pledgeStatus: number;
  pledgeFee: number;
  rzstatus: number;
  createTime: Date | null;
  updateTime: Date | null;
}>("domainSignal");